import { getUserAgent } from 'react-native-device-info';
import { isWeb } from 'shared/constants/platform';
import {
  handleFetchError,
  handleNetworkError,
  isBaseNetworkError,
} from 'shared/utils/errors';

const unauthenticatedFetch = async (
  url: string,
  options?: RequestInit,
): Promise<Response> => {
  const userAgent = await getUserAgent();
  const headers = new Headers({
    ...options?.headers,
    ...(isWeb ? {} : { 'User-Agent': userAgent }),
  });

  const fetchOptions: RequestInit = {
    ...options,
    headers,
  };

  try {
    const response = await fetch(url, fetchOptions);

    if (!response.ok) {
      await handleFetchError(response);
    }

    return response;
  } catch (error) {
    if (isBaseNetworkError(error)) {
      throw error; // already classified by handleFetchError
    }
    if (options?.signal?.aborted) {
      throw error;
    }
    return handleNetworkError(error);
  }
};

export default unauthenticatedFetch;
